import * as server from '../entries/pages/o-kancelarii/_page.server.ts.js';

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/o-kancelarii/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/o-kancelarii/+page.server.ts";
export const imports = ["_app/immutable/nodes/8.B_AtZbCu.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/DwKR0wUy.js","_app/immutable/chunks/DmC62j6_.js"];
export const stylesheets = [];
export const fonts = [];
